import { Injectable } from '@angular/core';
import {
  Action,
  NgxsAfterBootstrap,
  State,
  StateContext,
  Store,
} from '@ngxs/store';
import { Assessment } from '../../../../types/assessment';
import { ASSESSMENT_LIST_STATE } from '../../../../types/state-name';
import {
  AddAssessmentAction,
  FetchAssessmentListAction,
} from '../actions/assessment-list.action';
import { retry, tap } from 'rxjs';
import { AssessmentServiceNew } from '../../../../../sdk/src/lib/services/assessment-new.service';
import { AuthService } from '@auth0/auth0-angular';
import {
  CYPRESS_TEST_CREATED_USER_ID_1,
  CYPRESS_TEST_CREATED_USER_ID_2,
} from '../../../../values/static-values';

@State<Array<Assessment>>({
  name: ASSESSMENT_LIST_STATE,
  defaults: [],
})
@Injectable({
  providedIn: 'root',
})
export class AssessmentListState implements NgxsAfterBootstrap {
  cypressTestUserIDForStratCare = CYPRESS_TEST_CREATED_USER_ID_1;
  cypressTestUserIDForUsualCare = CYPRESS_TEST_CREATED_USER_ID_2;

  constructor(
    private _store: Store,
    private _assessmentService: AssessmentServiceNew,
    private _authService: AuthService
  ) {}

  ngxsAfterBootstrap() {
    // Check if user is authenticated with Auth0
    this._authService.isAuthenticated$
      .pipe(
        tap((isAuthenticated) => {
          if (isAuthenticated) {
            this._authService.user$
              .pipe(
                tap((user) => {
                  if (user?.sub) {
                    this._store.dispatch(
                      new FetchAssessmentListAction(user.sub)
                    );
                  }
                })
              )
              .subscribe();
          }
        })
      )
      .subscribe();
  }

  static getAssessmentState(state: any) {
    return state[ASSESSMENT_LIST_STATE];
  }

  @Action(FetchAssessmentListAction)
  fetchAssessmentList(stateContext: StateContext<Array<Assessment>>) {
    return this._assessmentService.getAllAssessmentList().pipe(
      retry(3),
      tap((assessmentList) => {
        let FILTERED_ASSESSMENT_LIST: Array<Assessment> = [];
        FILTERED_ASSESSMENT_LIST = assessmentList.filter(
          (filterAssessment: Assessment) =>
            filterAssessment.creator_user_id !==
              this.cypressTestUserIDForStratCare &&
            filterAssessment.creator_user_id !==
              this.cypressTestUserIDForUsualCare
        );
        return stateContext.setState([...FILTERED_ASSESSMENT_LIST]);
      })
    );
  }

  @Action(AddAssessmentAction)
  addAssessment(
    stateContext: StateContext<Array<Assessment>>,
    addAssessmentAction: AddAssessmentAction
  ) {
    const ASSESSMENT_LIST = [...stateContext.getState()];
    ASSESSMENT_LIST.push(addAssessmentAction.assessment);

    stateContext.setState(ASSESSMENT_LIST);
  }
}
